"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bigint = void 0;
var helpers_1 = require("../utils/helpers");
var guard_1 = require("../guard");
var BIGINT_SCHEMA = Object.freeze({ type: 'bigint' });
/**
 * Contructs a type-guard for a `bigint`
 * @param options.maximum - inclusive maximal value
 * @param options.minimum - inclusive minimum value
 * @param options.exclusiveMaximum - exclusive maximal value
 * @param options.exclusiveMinimum - exclusive minial value
 * @param options.multipleOf - value must be multiple of integer
 * @param options.even - value must be evenly divisible by 2
 * @param options.odd - value should not be evenly divisible by 2
 */
function bigint(options) {
    var _a = __assign({}, options), exclusiveMaximum = _a.exclusiveMaximum, exclusiveMinimum = _a.exclusiveMinimum, maximum = _a.maximum, minimum = _a.minimum, multipleOf = _a.multipleOf, even = _a.even, odd = _a.odd;
    if (exclusiveMaximum !== undefined && typeof exclusiveMaximum !== 'bigint') {
        throw new Error('"exclusiveMaximum" must be undefined or a bigint');
    }
    if (exclusiveMinimum !== undefined && typeof exclusiveMinimum !== 'bigint') {
        throw new Error('"exclusiveMinimum" must be undefined or a bigint');
    }
    if (maximum !== undefined && typeof maximum !== 'bigint') {
        throw new Error('"maximum" must be undefined or a bigint');
    }
    if (minimum !== undefined && typeof minimum !== 'bigint') {
        throw new Error('"minimum" must be undefined or a bigint');
    }
    if (multipleOf !== undefined && typeof multipleOf !== 'bigint') {
        throw new Error('"multipleOf" must be undefined or a bigint');
    }
    if (even !== undefined && typeof even !== 'boolean') {
        throw new Error('"even" must be undefined or a boolean');
    }
    if (odd !== undefined && typeof odd !== 'boolean') {
        throw new Error('"odd" must be undefined or a boolean');
    }
    return new guard_1.TypeGuard(BIGINT_SCHEMA, function (value) {
        return value;
    }, function (value) {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(typeof value !== 'bigint')) return [3 /*break*/, 2];
                    return [4 /*yield*/, {
                            path: [],
                            rule: 'type',
                            setting: 'bigint',
                            actual: helpers_1.actualTypeOf(value)
                        }];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 16];
                case 2:
                    if (!(exclusiveMaximum !== undefined && exclusiveMaximum <= value)) return [3 /*break*/, 4];
                    return [4 /*yield*/, {
                            path: [],
                            rule: 'exclusiveMaximum',
                            setting: exclusiveMaximum,
                            actual: value
                        }];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    if (!(exclusiveMinimum !== undefined && exclusiveMinimum >= value)) return [3 /*break*/, 6];
                    return [4 /*yield*/, {
                            path: [],
                            rule: 'exclusiveMinimum',
                            setting: exclusiveMinimum,
                            actual: value
                        }];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6:
                    if (!(maximum !== undefined && maximum < value)) return [3 /*break*/, 8];
                    return [4 /*yield*/, {
                            path: [],
                            rule: 'maximum',
                            setting: maximum,
                            actual: value
                        }];
                case 7:
                    _a.sent();
                    _a.label = 8;
                case 8:
                    if (!(minimum !== undefined && minimum > value)) return [3 /*break*/, 10];
                    return [4 /*yield*/, {
                            path: [],
                            rule: 'minimum',
                            setting: minimum,
                            actual: value
                        }];
                case 9:
                    _a.sent();
                    _a.label = 10;
                case 10:
                    if (!(multipleOf !== undefined && value % multipleOf !== 0n)) return [3 /*break*/, 12];
                    return [4 /*yield*/, {
                            path: [],
                            rule: 'multipleOf',
                            setting: multipleOf,
                            actual: value
                        }];
                case 11:
                    _a.sent();
                    _a.label = 12;
                case 12:
                    if (!(even === true && value !== 0n && value % 2n !== 0n)) return [3 /*break*/, 14];
                    return [4 /*yield*/, {
                            path: [],
                            rule: 'even',
                            setting: even,
                            actual: value
                        }];
                case 13:
                    _a.sent();
                    _a.label = 14;
                case 14:
                    if (!(odd === true && (value === 0n || (value < 0n ? -1n * value : value) % 2n !== 1n))) return [3 /*break*/, 16];
                    return [4 /*yield*/, {
                            path: [],
                            rule: 'odd',
                            setting: odd,
                            actual: value
                        }];
                case 15:
                    _a.sent();
                    _a.label = 16;
                case 16: return [2 /*return*/];
            }
        });
    });
}
exports.bigint = bigint;
